// screen: Forgot / reset password
import * as React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { ApiError } from '@viewstream/api-client';
import { Button, Field, Input, EmptyState } from '@viewstream/ui';
import { api } from '~/app/api';
import { ProductName } from '~/app/brand';

export const Route = createFileRoute('/password/reset')({
  validateSearch: (s: Record<string, unknown>) => ({ token: typeof s['token'] === 'string' ? s['token'] : '' }),
  component: Reset,
});

function Reset() {
  const { t } = useLingui();
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const [password, setPassword] = React.useState('');
  const [err, setErr] = React.useState<string | null>(null);
  const [busy, setBusy] = React.useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await api.POST('/v1/auth/password/reset', { body: { token, password } }); void navigate({ to: '/login', search: { next: undefined } }); }
    catch (ex) { setErr(ex instanceof ApiError ? (ex.isNotFound ? t`This link is invalid or expired, or password reset is not deployed yet.` : (ex.problem?.detail ?? ex.message)) : String(ex)); }
    finally { setBusy(false); }
  }
  if (!token) return <main className="p-6"><EmptyState title={t`Missing reset token`} /></main>;
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-xl border border-border bg-surface p-8 shadow-card">
        <div className="mb-6"><ProductName /></div>
        <form onSubmit={submit} noValidate>
          <h1 className="mb-4 text-xl font-semibold">{t`Choose a new password`}</h1>
          <Field id="password" label={t`New password`} hint={t`At least 12 characters. Other sessions will be signed out.`} error={err}><Input type="password" minLength={12} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} dir="ltr" /></Field>
          <Button type="submit" className="w-full" loading={busy}>{t`Save password`}</Button>
        </form>
      </div>
    </main>
  );
}
